<script setup lang="ts">
const slots = useSlots();

const hasSlot = (name: string): boolean => {
    return !!slots[name];
};
</script>

<template>
    <header class="flex items-center justify-between pb-[8px]">
        <div>
            <h1 class="flex text-[28px] font-[300] gap-x-2 items-center">
                <template v-if="hasSlot('default')">
                    <slot />
                </template>
            </h1>

            <div v-if="hasSlot('desc')">
                <slot name="desc" />
            </div>
        </div>
        <div
            v-if="hasSlot('actions')"
            class="flex justify-end flex-row"
        >
            <slot name="actions" />
        </div>
    </header>
</template>
